import { useEffect } from "react";
import { SvgIcons } from "../SvgIcons/SvgIcons";
import styles from "./style.module.css";

// overlayClassName (optional) styles the backdrop, e.g. a blur; unset, the overlay is unchanged.
export const Popup = ({ children, onClose, contentClassName = "", overlayClassName = "", hideCloseButton = false }) => {
    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };
        document.body.style.overflow = "hidden";
        document.addEventListener("keydown", handleEsc);
        return () => {
            document.body.style.overflow = "auto";
            document.removeEventListener("keydown", handleEsc);
        };
    }, [onClose]);
    return (
        <div className={`${styles.overlay} ${overlayClassName}`} onClick={onClose}>
            <div className={`${styles.content} ${contentClassName}`} onClick={e => e.stopPropagation()}>
                {!hideCloseButton && (
                    <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">
                        <SvgIcons name="cross_btn" style={{ width: "20px", height: "20px", color: "#999" }} />
                    </button>
                )}
                {children}
            </div>
        </div>
    );
};
